import { Injectable } from '@angular/core'

const PAPI_DEFAULT_APP = 'papi-default-app'

@Injectable({ providedIn: 'root' })
export class DefaultRouteService {
  defaultAppId = localStorage[PAPI_DEFAULT_APP]

  saveDefaultApp(appId: string) {
    localStorage[PAPI_DEFAULT_APP] = this.defaultAppId = appId
  }
}
